var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// stores/CardOrderStore.ts
import { observable, action, runInAction } from 'mobx';
import { api } from '../../helpers/Api';
var CardOrderStore = /** @class */ (function () {
    function CardOrderStore() {
        var _this = this;
        this.cards = [];
        this.loading = true;
        this.saving = false;
        this.dirty = false;
        this.load = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.loading = true;
                try {
                    /*const res = await fetch(`${this.apiBase}/clients/${this.clientId}/card-experiences`)
                    const data: CardExperience[] = await res.json()*/
                    return [2 /*return*/, api.get('cardExperiences').then(function (data) {
                            runInAction(function () {
                                console.log('load - data: ', data);
                                _this.cards = data;
                                _this.loading = false;
                            });
                        })];
                }
                catch (err) {
                    runInAction(function () { _this.loading = false; });
                    throw err;
                }
                return [2 /*return*/];
            });
        }); };
        this.reorder = function (fromIndex, toIndex) {
            var items = _this.cards.slice();
            var moved = items.splice(fromIndex, 1)[0];
            items.splice(toIndex, 0, moved);
            items.forEach(function (c, idx) { c.order = idx + 1; });
            _this.cards = items;
            _this.dirty = true;
        };
        this.moveToPosition = function (cardId, targetPosition) {
            var fromIndex = _this.cards.findIndex(function (c) { return c.id === cardId; });
            if (fromIndex === -1)
                return -1;
            var toIndex = Math.min(Math.max(targetPosition - 1, 0), _this.cards.length - 1);
            if (toIndex === fromIndex)
                return toIndex;
            _this.reorder(fromIndex, toIndex);
            return toIndex;
        };
        this.save = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.saving = true;
                try {
                    /*await fetch(`${this.apiBase}/clients/${this.clientId}/card-experiences/order`, {
                      method: 'PUT',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify(this.cards.map(({ id, order }) => ({ id, order }))),
                    })
                    */
                    api.put("cardExperiences", this.cards.map(function (_a) {
                        var id = _a.id, order = _a.order;
                        return ({ id: id, order: order });
                    })).then(function (result) {
                        runInAction(function () {
                            _this.dirty = false;
                            _this.saving = false;
                        });
                    });
                }
                catch (err) {
                    runInAction(function () { _this.saving = false; });
                    throw err;
                }
                return [2 /*return*/];
            });
        }); };
    }
    __decorate([
        observable
    ], CardOrderStore.prototype, "cards", void 0);
    __decorate([
        observable
    ], CardOrderStore.prototype, "loading", void 0);
    __decorate([
        observable
    ], CardOrderStore.prototype, "saving", void 0);
    __decorate([
        observable
    ], CardOrderStore.prototype, "dirty", void 0);
    __decorate([
        action
    ], CardOrderStore.prototype, "load", void 0);
    __decorate([
        action
    ], CardOrderStore.prototype, "reorder", void 0);
    __decorate([
        action
    ], CardOrderStore.prototype, "moveToPosition", void 0);
    __decorate([
        action
    ], CardOrderStore.prototype, "save", void 0);
    return CardOrderStore;
}());
export default CardOrderStore;



//////////////////
// WEBPACK FOOTER
// ./src/modules/CardExperiences/Store.ts
// module id = 334
// module chunks = 0